import {filterObject} from '@/helpers/utils';
import {flattenBlockMaterials} from '@/components/pages/roadmap/manual/composable/helpers';

export const gettersTypes = {
  activeListFilters: '[roadmap-manual] active list filters',
  countActiveListFilters: '[roadmap-manual] count active list filters',
  dirtyListFilters: '[roadmap-manual] dirty list filters',
  activeSupervisedFilters: '[roadmap-manual] active supervised filters',
  countActiveSupervisedFilters: '[roadmap-manual] count active supervised filters',
  dirtySupervisedFilters: '[roadmap-manual] dirty supervised filters',
  editableFields: '[roadmap-manual] editable fields',
  availableActions: '[roadmap-manual] available actions',
  canChangeStatus: '[roadmap-manual] can change status',
  canEditField: '[roadmap-manual] can edit field',
  canRunAction: '[roadmap-manual] can run action',
  hasManualMaterials: '[roadmap-manual] has manual materials',
  waitingRoadmapsCount: '[roadmap-manual] waiting roadmaps count',
};

const getters = {
  [gettersTypes.activeListFilters]: (state) => {
    return filterObject(state.listFilters, (value, key) => {
      if (key === 'period') return Boolean(value?.dateStart && value?.dateEnd);

      return Array.isArray(value)
        ? Boolean(value.length)
        : value !== null && value !== undefined && value !== '';
    });
  },

  [gettersTypes.countActiveListFilters]: (state, getters) => {
    return Object.keys(getters[gettersTypes.activeListFilters]).length;
  },

  [gettersTypes.dirtyListFilters]: (state, getters) => {
    return Boolean(getters[gettersTypes.countActiveListFilters]);
  },

  [gettersTypes.activeSupervisedFilters]: (state) => {
    return filterObject(state.supervisedFilters, (value, key) => {
      if (key === 'period') return Boolean(value?.dateStart || value?.dateEnd);
      if (key === 'waitingDecision') return value === true;

      return Array.isArray(value)
        ? Boolean(value.length)
        : value !== null && value !== undefined && value !== '';
    });
  },

  [gettersTypes.countActiveSupervisedFilters]: (state, getters) => {
    return Object.keys(getters[gettersTypes.activeSupervisedFilters]).length;
  },

  [gettersTypes.dirtySupervisedFilters]: (state, getters) => {
    return Boolean(getters[gettersTypes.countActiveSupervisedFilters]);
  },

  [gettersTypes.editableFields]: (state) => {
    if (!state.header || !Array.isArray(state.header.editable_fields)) return [];
    return state.header.editable_fields;
  },
  [gettersTypes.availableActions]: (state) => {
    if (!state.header || !Array.isArray(state.header.available_actions)) return [];
    return state.header.available_actions;
  },
  [gettersTypes.canChangeStatus]: (state) => {
    return Boolean(state.header?.can_change_status);
  },
  [gettersTypes.canEditField]: (state, getters) => (field) => {
    return getters[gettersTypes.editableFields].includes(field);
  },
  [gettersTypes.canRunAction]: (state, getters) => (action) => {
    return getters[gettersTypes.availableActions].includes(action);
  },
  [gettersTypes.hasManualMaterials]: (state) => {
    const hasManualCommonMaterial = (state.commonMaterials || []).some(
      (material) => material.is_manual
    );
    const hasManualBlockMaterial = flattenBlockMaterials(state.blockMaterials).some(
      (material) => material.is_manual
    );

    return hasManualCommonMaterial || hasManualBlockMaterial;
  },
  [gettersTypes.waitingRoadmapsCount]: (state) => {
    if (!state.supervisedBadge) return 0;
    return state.supervisedBadge.waiting_count || 0;
  },
};

export default getters;
